export const AUTH_CHECK_STATE = 'AUTH_CHECK_STATE';
export const AUTH_USER = 'AUTH_USER';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_CHECK_TIMEOUT = 'AUTH_CHECK_TIMEOUT';
export const AUTH_INITIATE_LOGOUT = 'AUTH_INITIATE_LOGOUT';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';

export const POKEDEX_LIST_LOAD = 'POKEDEX_LIST_LOAD';
export const POKEDEX_LIST_LOAD_START = 'POKEDEX_LIST_LOAD_START';
export const POKEDEX_LIST_LOAD_SUCCESS = 'POKEDEX_LIST_LOAD_SUCCESS';
export const POKEDEX_LIST_LOAD_FAIL = 'POKEDEX_LIST_LOAD_FAIL';
export const POKEDEX_POKEMON_LOAD = 'POKEDEX_POKEMON_LOAD';
export const POKEDEX_POKEMON_LOAD_START = 'POKEDEX_POKEMON_LOAD_START';
export const POKEDEX_POKEMON_LOAD_SUCCESS = 'POKEDEX_POKEMON_LOAD_SUCCESS';
export const POKEDEX_POKEMON_LOAD_FAIL = 'POKEDEX_POKEMON_LOAD_FAIL';

export const ADD_CAPTURED_POKEMON = 'ADD_CAPTURED_POKEMON';
export const ADD_CAPTURED_POKEMON_SUCCESS = 'ADD_CAPTURED_POKEMON_SUCCESS';
export const ADD_CAPTURED_POKEMON_FAILED = 'ADD_CAPTURED_POKEMON_FAILED';
export const REMOVE_CAPTURED_POKEMON = 'REMOVE_CAPTURED_POKEMON';
export const REMOVE_CAPTURED_POKEMON_SUCCESS = 'REMOVE_CAPTURED_POKEMON_SUCCESS';
export const REMOVE_CAPTURED_POKEMON_FAILED = 'REMOVE_CAPTURED_POKEMON_FAILED';
export const FETCH_CAPTURED_POKEMONS = 'FETCH_CAPTURED_POKEMONS';
export const FETCH_CAPTURED_POKEMONS_START = 'FETCH_CAPTURED_POKEMONS_START';
export const FETCH_CAPTURED_POKEMONS_SUCCESS = 'FETCH_CAPTURED_POKEMONS_SUCCESS';
export const FETCH_CAPTURED_POKEMONS_FAILED = 'FETCH_CAPTURED_POKEMONS_FAILED';

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';